module.exports = __webpack_public_path__ + "static/hooks-e09434f234016fbd13ac853552034a71.png";